import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAllIntakeEvents, updateIntakeEvent, retryFilename } from '../requests/intakeEvent';

const KEY = 'intakeEvent';

const useGetAllIntakeEvents = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: (data) => getAllIntakeEvents(data),
});

// The open events count in the menu changes when an event is closed or retried
const useRefreshOpenCount = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [KEY, 'openCount'] });
};

const useUpdateIntakeEvent = () => {
  const refreshOpenCount = useRefreshOpenCount();
  return useMutation({
    mutationKey: [KEY, 'update'],
    mutationFn: (data) => updateIntakeEvent(data),
    onSuccess: refreshOpenCount,
  });
};

const useRetryFilename = () => {
  const refreshOpenCount = useRefreshOpenCount();
  return useMutation({
    mutationKey: [KEY, 'retryFilename'],
    mutationFn: (data) => retryFilename(data),
    onSuccess: refreshOpenCount,
  });
};

const intakeEventMutations = {
  useGetAllIntakeEvents,
  useUpdateIntakeEvent,
  useRetryFilename,
};

export default intakeEventMutations;
